import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { setSelectedNode } from '../../../features/networkSlice';

export default function handler(props) {
  const { visible } = props; // indicates if the tab is visible (otherwise DataGrid will complain)
  const nodes = useSelector((state) => state.networkUndo.present.nodes);
  const edges = useSelector((state) => state.networkUndo.present.edges);

  const highlightedNodes = useSelector((state) => state.network.highlightedNodes) || [];
  const highlightedEdges = useSelector((state) => state.network.highlightedEdges) || [];

  let connectedNodes = [];
  if (highlightedNodes.length === 0) { // if only edges are selected
    connectedNodes = highlightedEdges.flatMap((edgeId) => {
      const edgeIndex = edges.findIndex((edge) => edge.id === edgeId);
      if (edgeIndex !== -1) {
        return [parseInt(edges[edgeIndex].to, 10), parseInt(edges[edgeIndex].from, 10)];
      }
      return [];
    });
  }

  const filteredNodes = nodes.filter((node) => {
    if (highlightedNodes.length === 0 && highlightedEdges.length === 0) return true;
    if (highlightedNodes.includes(node.id)) return true;
    if (connectedNodes.length > 0 && connectedNodes.includes(node.id)) return true;
    return false;
  });

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'label', headerName: 'Label', flex: 3 },
    { field: 'title', headerName: 'Description', flex: 6 },
  ];
  const initialState = { pagination: { paginationModel: { pageSize: 50 } } };

  const dispatch = useDispatch();

  const onRowClick = (e) => { // 'onRowDoubleClick' also available
    dispatch(setSelectedNode(e.row));
  };

  function CustomFilter() {
    return <GridToolbarQuickFilter sx={{ p: 2 }} />;
  }

  return (visible && (
    <>
      <DataGrid
        autoHeight
        getRowHeight={() => 'auto'}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            alignItems: 'start',
            py: 1,
          },
          border: 0,
        }}
        rows={filteredNodes}
        columns={columns}
        initialState={initialState}
        onRowClick={onRowClick}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25, 50]}
        components={{ Toolbar: CustomFilter }}
      />
      {(highlightedEdges.length > 0 || highlightedNodes.length > 0) && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          The rows are filtered based on selections
        </Alert>
      )}
    </>
  ));
}
/*
Helpful resources:

- https://mui.com/x/react-data-grid/row-selection/
- https://mui.com/x/react-data-grid/cell-selection/
*/
